// Center-of-table: closed deck, open discard, wild-joker reveal, declare slot.

import Card, { type CardData } from './Card';

export default function CenterTable({
  topDiscard, wildCard, wildRank, onDrawClosed, onDrawOpen,
}: {
  topDiscard: CardData | null;
  wildCard: CardData | null;
  wildRank: string | null;
  onDrawClosed: () => void;
  onDrawOpen: () => void;
}) {
  return (
    <div className="rummy-center">
      {/* Wild joker reveal — face-up, tilted, to the far left. */}
      {wildCard && (
        <div style={{ transform: 'rotate(-90deg)', marginRight: 6 }}>
          <Card card={wildCard} />
          <div className="rummy-label" style={{ top: -22, bottom: 'auto', transform: 'translateX(-50%) rotate(90deg)' }}>
            WILD {wildRank ? `(${wildRank})` : ''}
          </div>
        </div>
      )}

      {/* Closed deck — 3-card stack, click to draw. */}
      <div className="rummy-deck-stack" onClick={onDrawClosed} role="button" tabIndex={0}>
        <div className="rummy-card-back rummy-deck-stack__back" style={{ transform: 'translate(4px,-4px)' }} />
        <div className="rummy-card-back rummy-deck-stack__back" style={{ transform: 'translate(2px,-2px)' }} />
        <div className="rummy-card-back rummy-deck-stack__back" />
        <div className="rummy-label">DRAW</div>
      </div>

      {/* Open discard pile — drop-zone for discards. Click to draw top. */}
      <div
        id="rummy-discard-pile"
        className="drop-zone"
        style={{ position: 'relative', width: 48, height: 68 }}
        onClick={(e) => {
          // Only fire draw when clicking the card itself (not drop).
          if ((e.target as HTMLElement).closest('.rummy-card')) onDrawOpen();
        }}
      >
        {topDiscard
          ? <Card card={topDiscard} />
          : <div className="rummy-card-back" style={{ opacity: 0.2 }} />}
        <div className="rummy-label">DISCARD</div>
      </div>

      {/* Declare slot — drop the 14th face-down card here. */}
      <div id="rummy-declare-slot" className="rummy-declare-slot drop-zone">
        DROP<br/>HERE<br/>TO<br/>DECLARE
      </div>
    </div>
  );
}
